// UsagesFilter.js - Closes when usage is selected

import { useEffect, useState } from "react";
import { Checkbox } from "reusableComponents";
import FiltersButton from "../FiltersButton";
import { getUsageOptions } from "services/filters.services";
import { useTranslation } from "react-i18next";
import { useLanguage } from "context/languageContext";
import styles from "./styles.module.scss";

const UsagesFilter = ({
  selectedUsages = [],
  onUsageChange,
}) => {
  const { t } = useTranslation("global");
  const [showUsagesDropdown, setShowUsagesDropdown] = useState(true); // Start open by default
  const [usagesOptions, setUsagesOptions] = useState([]);
  const { language } = useLanguage();

  useEffect(() => {
    const fetchUsagesOptions = async () => {
      const usages = await getUsageOptions(language);
      setUsagesOptions(usages || []);
    };
    fetchUsagesOptions();
  }, [language]);

  const toggleShowUsagesDropdown = () => {
    setShowUsagesDropdown((prevState) => !prevState);
  };

  const handleUsageChange = (option) => {
    const isSelected = selectedUsages.includes(option.key);
    const updatedFilters = isSelected
      ? [] // Deselect if the same option is chosen again
      : [option.key]; // Only allow one option to be selected

    onUsageChange(updatedFilters);
    
    // Close dropdown when a usage is selected (not when deselecting)
    if (!isSelected) {
      setShowUsagesDropdown(false);
    }
  };

  // Get button label - matches CapacityFilter pattern
  const getButtonLabel = () => {
    if (selectedUsages.length > 0) {
      const selectedUsage = usagesOptions.find(
        (usage) => usage.key === selectedUsages[0]
      );
      return selectedUsage ? selectedUsage.name : t("search.defaultUsage");
    }
    return t("search.defaultUsage");
  };

  return (
    <div className={styles.usagesWrapper}>
      <FiltersButton
        label={getButtonLabel()}
        isActive={!!selectedUsages.length}
        onClick={toggleShowUsagesDropdown}
      />
      <div
        className={`${styles.usagesDropdownBody} ${
          showUsagesDropdown ? styles.visible : styles.hidden
        }`}
      >
        {usagesOptions.map((usage) => (
          <div 
            key={usage.id} 
            className={styles.usageOption}
          >
            <Checkbox
              checked={selectedUsages.includes(usage.key)}
              onChange={() => handleUsageChange(usage)}
              label={usage.name}
              greyText={true}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default UsagesFilter;